/* eslint-disable */
export default {
  downloadSuccess: '日志已下载。',
  downloadFail: '错误日志下载失败。请再试一次。',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
